import styled from '@emotion/styled'
import { Radio, Button, Popconfirm, notification, Layout } from 'antd'
import React, { useEffect, useMemo, useState } from 'react'
import { RepasseModel, TurmaModelWithVagasPreenchidas } from '../../../../components/models/Models'
import { AgendarStore, IState, selectCfcsDestino } from '../AgendarStore'
import { format, parseISO, addDays } from 'date-fns'
import useAxios from 'axios-hooks'
import { QuantidadeVagas } from '../../../../components/turmas/QuantidadeVagas'
import { Show } from '../../../../components/common/Show'
import { ReactComponent as NotFoundSVG } from '../../../../assets/icons/search.svg'
import { ReactComponent as Plus } from '../../../../assets/icons/icon-plus.svg'
import { ReactComponent as Minus } from '../../../../assets/icons/icon-minus.svg'
import { isValid as isCpfValid } from '@fnando/cpf'
import { Collapse } from 'antd'
import { TailSpin } from 'react-loader-spinner'
import { formatMoeda } from '../../../../components/common/Utils'
import { StopPropagation } from '../../../../components/common/StopPropagation'
import { ReactComponent as Warining } from '../../../../assets/icons/warning2.svg'
import { notificationPilotar } from '../notificationPilotar'
const { Panel } = Collapse

const TurmasDisponiveis = () => {
  const dispatch = AgendarStore.useDispatch()
  const { agendamento } = AgendarStore.useState()

  React.useEffect(() => {
    dispatch(AgendarStore.thunks.getTurmas(agendamento?.cfcDestino?.id, agendamento.tipoCurso))
  }, [agendamento])

  return (
    <div>
      <TurmasPorCfc />
    </div>
  )
}

export const Modalidades = () => {
  const { Layout } = Modalidades
  const { turmas, modalidade } = AgendarStore.useState()
  const dispatch = AgendarStore.useDispatch()

  function handleChangeModalidade(e: any) {
    dispatch(AgendarStore.actions.changeModalidade(e.target.value))
  }

  const filteredTurmas = turmas.filter((t: any) => t.modalidade === (modalidade as any))

  return (
    <Show condition={!!filteredTurmas.length}>
      <Layout>
        <Radio.Group
          size="large"
          buttonStyle="solid"
          value={modalidade}
          onChange={handleChangeModalidade}
        >
          <Radio.Button type="primary" value="MATUTINO">
            Matutino
          </Radio.Button>
          <Radio.Button type="primary" value="VESPERTINO">
            Vespertino
          </Radio.Button>
          <Radio.Button type="primary" value="NOTURNO">
            Noturno
          </Radio.Button>
          <Radio.Button type="primary" value="INTENSIVO">
            Intensivo
          </Radio.Button>
        </Radio.Group>
      </Layout>
    </Show>
  )
}
Modalidades.Layout = styled.div`
  padding: 24px;
  text-align: center;
`

export const TabelaTurmas = () => {
  const { turmasInfo, agendamento, loadingTurmas, cfcsDestino, municipio } = AgendarStore.useState()
  const { Layout, Text, EmptyState, ContainerInfo, CardContainer, PanelAntd } = TabelaTurmas
  const [currentKey, setCurrentKey] = useState(null)

  if (loadingTurmas) {
    return (
      <>
        <TailSpin
          color="#FBBA3E"
          height={80}
          width={80}
          visible={loadingTurmas}
          wrapperStyle={{
            width: '90px',
            margin: 'auto',
            marginTop: '20px',
            display: 'flex',
            justifyContent: 'center',
          }}
        />
      </>
    )
  }

  if (
    !municipio ||
    !agendamento.cfcOrigem ||
    !turmasInfo ||
    !cfcsDestino ||
    !turmasInfo.turmas.length
  ) {
    return (
      <EmptyState>
        <NotFoundSVG className="not-found-svg" width={167} height={77} />
        <ContainerInfo>
          <strong>
            Não existe nenhuma turma cadastrada para o município ou tipo de curso selecionado
          </strong>
          <span>Selecione outro município ou outro tipo de curso</span>
        </ContainerInfo>
      </EmptyState>
    )
  }

  const { totalTurmasDisponiveis, turmas } = turmasInfo
  const cfcIds = totalTurmasDisponiveis.map((total) => total.cfc.id)

  let modalidadesPorCfc: any = []
  cfcIds.forEach((cfcId) => {
    modalidadesPorCfc.push({
      cfcId,
      modalidades: new Set(
        turmas.filter((turma) => turma.cfcId === cfcId).map((turma) => turma.modalidade)
      ),
    })
  })

  const qtdVagasPorCfc: any = []
  cfcIds.forEach((cfcId) => {
    qtdVagasPorCfc.push({
      cfcId,
      qtdVagas: turmas
        .filter((turma) => turma.cfcId === cfcId)
        .map((turma) => +turma.qtdVagasRegulares),
    })
  })

  const qtdVagasPreenchidasPorCfc: any = []
  cfcIds.forEach((cfcId) => {
    qtdVagasPreenchidasPorCfc.push({
      cfcId,
      qtdVagasRegularPreenchidas: turmas
        .filter((turma) => turma.cfcId === cfcId)
        .map((turma: any) => +turma.qtdVagasRegularesPreenchidas)
        .reduce((acc: number, next: number) => {
          return (acc += next)
        }, 0),
    })
  })

  function changeTurmaLinha(key: any) {
    setCurrentKey(key)
  }

  if (!agendamento.telefone) return <></>

  return (
    <>
      <Layout>
        <Text>Turmas disponíveis</Text>
        <Collapse
          accordion={true}
          expandIconPosition={'right'}
          bordered={false}
          ghost={true}
          style={{ padding: '0px', display: 'flex', flexDirection: 'column', gap: '20px' }}
          expandIcon={({ isActive }) => (isActive ? <Minus /> : <Plus />)}
          onChange={changeTurmaLinha}
        >
          {totalTurmasDisponiveis?.map((turmaInfo) => {
            return (
              <PanelAntd
                currentKey={
                  !!currentKey && currentKey == turmaInfo.cfc?.id.toString() ? true : false
                }
                key={turmaInfo?.cfc?.id}
                header={
                  <LinhaHeader
                    turmaInfo={turmaInfo}
                    modalidadesPorCfc={modalidadesPorCfc}
                    qtdVagasPreenchidasPorCfc={qtdVagasPreenchidasPorCfc}
                    qtdVagasPorCfc={qtdVagasPorCfc}
                  />
                }
              >
                <CardContainer>
                  {turmas
                    .filter((turma: any) => turma.cfcId === turmaInfo.cfc.id)
                    .map((turma: any) => {
                      return <CardTurma key={turma.id} turma={turma} />
                    })}
                </CardContainer>
                <ResumoPagamento turmaInfo={turmaInfo} />
              </PanelAntd>
            )
          })}
        </Collapse>
      </Layout>
    </>
  )
}

TabelaTurmas.Layout = styled.div`
  margin-top: 30px;
`
TabelaTurmas.PanelAntd = styled<any>(Panel)`
  background: ${(props) => (props.currentKey ? '#F6F6F6' : '#FFFFFF')};
  border: 1px solid #e1e1e1 !important;
  border-radius: 8px;
`
TabelaTurmas.CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 12px;
  padding: 16px;
  background: #f6f6f6;
  border-top: 1px solid #e1e1e1;
`
TabelaTurmas.Text = styled.h3`
  font-weight: 600;
  font-size: 20px;
  color: #3a3a3a;
`
TabelaTurmas.EmptyState = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  justify-content: center;
  flex-direction: column;
  gap: 20px;
  max-width: 610px;
  margin: 0 auto;
  padding: 15px;
  margin-top: 50px;
  svg {
    width: 167px;
    height: 77px;
  }
`

TabelaTurmas.ContainerInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
  text-align: center;
  strong {
    font-weight: 600;
    font-size: 25px;
    color: #3a3a3a;
    @media (max-width: 756px) {
      font-size: 19px;
    }
  }
  span {
    font-size: 16px;
    font-weight: 400;
    color: #343a40;
    @media (max-width: 756px) {
      font-size: 14px;
    }
  }
`

const LinhaHeader = ({
  turmaInfo,
  modalidadesPorCfc,
  qtdVagasPreenchidasPorCfc,
  qtdVagasPorCfc,
}: any) => {
  const { Layout, Celula, Circle, ContainerInfoCfc } = LinhaHeader

  return (
    <Layout>
      <Celula width={250}>{turmaInfo.cfc.fantasia}</Celula>
      <Celula>
        <ContainerInfoCfc>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '3px',
            }}
          >
            <span>Turmas</span> <Circle>{turmaInfo.total}</Circle>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '3px',
            }}
          >
            <span>Períodos</span>{' '}
            <Circle>
              {modalidadesPorCfc.find((el: any) => el.cfcId === turmaInfo.cfc.id).modalidades.size}{' '}
            </Circle>
          </div>
        </ContainerInfoCfc>
      </Celula>
      <Celula>
        <QuantidadeVagas
          quantidadeOcupada={
            qtdVagasPreenchidasPorCfc.find((el: any) => el.cfcId === turmaInfo.cfc.id)
              .qtdVagasRegularPreenchidas
          }
          quantidadeTotal={qtdVagasPorCfc
            .find((el: any) => el.cfcId === turmaInfo.cfc.id)
            .qtdVagas.reduce((acc: number, next: number) => {
              return (acc += next)
            }, 0)}
        />
      </Celula>
      <Celula className="boleto">
        <StopPropagation>
          <GerarCobranca fantasia={turmaInfo.cfc.fantasia} />{' '}
        </StopPropagation>
      </Celula>
    </Layout>
  )
}

LinhaHeader.Layout = styled.tr`
  font-weight: 600;
  font-size: 14px;
  color: #3a3a3a;
  padding: 7px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 30px;
  width: 100%;
  .boleto {
    margin-right: 15px;
  }
  @media (max-width: 756px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }
`
LinhaHeader.ContainerInfoCfc = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  gap: 35px;
  @media (max-width: 756px) {
    gap: 15px;
    justify-content: flex-start;
  }
`
LinhaHeader.Celula = styled.td<{ width?: number }>`
  text-align: start;
  ${({ width }) => (width ? `max-width: ${width}px;` : 'flex: 1 1 300px;')}
  @media (max-width: 756px) {
    flex: none;
    width: 100%;
  }
`
LinhaHeader.Circle = styled.div`
  background: #fbba3e;
  width: 22px;
  height: 22px;
  border-radius: 15px;
  color: #3a3a3a;
  text-align: center;
`

const CardTurma = ({ turma }: { turma: TurmaModelWithVagasPreenchidas }) => {
  const {
    Layout,
    Title,
    TextBold,
    ButtonContainer,
    TextLight,
    TextSmall,
    CancelButton,
    ContainerInfo,
    HeadInfo,
    ButtonAgendar,
    ModalConfirm,
    Icon,
    ContainerShadow,
    formatData,
  } = CardTurma
  const dataFim = new Date(
    calculaDataFimTurma({
      dataInicio: turma.dataInicio,
      modalidade: turma.modalidade,
      tipoCurso: turma.tipoCurso,
    })
  )
  const { agendamento, status, paramsPilotar, cfcsDestino } = AgendarStore.useState()
  const dispatch = AgendarStore.useDispatch()
  const [modalVisible, setModalVisible] = useState(false)

  const [{ data, loading }, reqAgendar] = useAxios(
    {
      method: 'POST',
      url: '/turmas/agendar',
      data: { agendamentoId: agendamento?.id, turmaId: turma.id },
    },
    {
      manual: true,
    }
  )

  async function handleConfirmAgendamento() {
    try {
      await reqAgendar().then((x) => x?.data)
      dispatch(AgendarStore.actions.agendarSuccess(turma.id))
      dispatch(AgendarStore.thunks.searchAgendamento(agendamento.cpf))
      notification.success({ message: 'Agendamento criado com sucesso!' })
      if (!!paramsPilotar) await notificationPilotar(agendamento, 'AGENDAMENTO', turma)
    } catch (error: any) {
      console.log(error)
      const message = error.response?.data?.message ?? 'Ocorreu um erro ao efetuar o agendamento'
      notification.error({ message })
    }
  }

  function openModalConfirm() {
    setModalVisible(!modalVisible)
  }

  return (
    <>
      <Layout>
        <Title style={{ fontSize: '15px' }}>{turma.modalidade}</Title>
        <TextLight>
          Data
          <TextBold>
            {formatData(turma.dataInicio)} à {formatData(dataFim.toISOString())}
          </TextBold>
        </TextLight>
        {
          <QuantidadeVagas
            style={{ marginBottom: '10px' }}
            quantidadeOcupada={turma?.qtdVagasRegularesPreenchidas}
            quantidadeTotal={turma.qtdVagasRegulares}
          />
        }
        <Show
          condition={
            (status === 'PAGO' && turma.qtdVagasRegularesPreenchidas < turma.qtdVagasRegulares) ||
            (!!agendamento.isCnhSocial && !!agendamento.identificadorCobranca)
          }
        >
          <ButtonAgendar disabled={!!agendamento.readOnly} onClick={openModalConfirm}>
            + Agendar
          </ButtonAgendar>
        </Show>
      </Layout>
      <Show condition={modalVisible}>
        <ContainerShadow>
          <ModalConfirm>
            <Warining className="warning" />
            <HeadInfo>
              <TextBold style={{ marginTop: '10px', fontSize: 20 }}>
                Deseja confirmar o agendamento?{' '}
              </TextBold>
              <TextSmall>Após confirmação, a ação só poderá ser revertida pelo CFC.</TextSmall>
            </HeadInfo>
            <ContainerInfo>
              <TextBold style={{ color: '#FBBA3E' }}>Turma {turma.modalidade}</TextBold>
              <TextSmall>
                Início: <strong>{formatData(turma.dataInicio)}</strong>{' '}
              </TextSmall>
              <TextSmall>
                Local: <strong>{agendamento.cfcDestino?.fantasia}</strong>
              </TextSmall>
            </ContainerInfo>
            <ButtonContainer>
              <CancelButton onClick={() => setModalVisible(false)}>Cancelar</CancelButton>
              <ButtonAgendar onClick={handleConfirmAgendamento}>
                <Show condition={!loading}>Sim, agendar</Show>
                <TailSpin
                  color="#FBBA3E"
                  height={25}
                  width={25}
                  visible={loading}
                  wrapperStyle={{
                    width: '25px',
                    marginLeft: '37px',
                  }}
                />
              </ButtonAgendar>
            </ButtonContainer>
          </ModalConfirm>
        </ContainerShadow>
      </Show>
    </>
  )
}

CardTurma.ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 5px;
  width: 100%;
  & > button {
    width: 100%;
  }
`

CardTurma.ContainerInfo = styled.div`
  display: grid;
  margin-bottom: 20px;
`

CardTurma.HeadInfo = styled.div`
  display: grid;
  margin-bottom: 10px;
`

CardTurma.ContainerShadow = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  background: rgba(24, 28, 42, 0.8);
  display: grid;
  place-items: center;
`

CardTurma.ModalConfirm = styled.div`
  display: block;
  max-width: 420px;
  height: 350px;
  position: absolute;
  padding: 40px 20px 20px 20px;
  background: #ffffff;
  border: 1px solid #ebebf9;
  border-radius: 8px;
  z-index: 2;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  .warning {
    height: 52px;
    width: 52px;
  }
  @media (max-width: 768px) {
    width: 100%;
    padding: 10px;
    height: 320px;
    .warning {
      height: 50px;
      width: 50px;
    }
  }
`
CardTurma.Icon = styled.img`
  width: 30px;
  height: 30px;
`
CardTurma.CancelButton = styled.button`
  display: flex;
  text-align: center;
  border-radius: 8px;
  padding: 8px 16px;
  width: 123px;
  height: 44px;
  box-sizing: border-box;
  font-size: 14px;
  font-weight: 600;
  gap: 4px;
  background: #ffffff;
  border: 1px solid #c2c2c2;
  justify-content: center;
  cursor: pointer;
  color: #898989;
`

CardTurma.ButtonAgendar = styled.button`
  display: flex;
  text-align: center;
  border-radius: 8px;
  padding: 8px 16px;
  height: 44px;
  max-width: 300px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  gap: 4px;
  flex-direction: row;
  align-items: center;
  background: #fbba3e;
  border: 1px solid #fbba3e;
  box-shadow: 0px 2px 8px rgba(81, 75, 57, 0.2);
  justify-content: center;
  border-radius: 8px;
  cursor: pointer;
  &:disabled {
    background: #c2c2c2;
    border: 1px solid #c2c2c2;
    cursor: not-allowed;
  }
`

CardTurma.Layout = styled.div`
  border-radius: 8px;
  padding: 16px;
  height: 210px;
  background: #ffffff;
  border: 1px solid #e1e1e1;
  display: grid;
  flex-direction: column;
  flex: 0 1 300px;
  @media (max-width: 900px) {
    flex: 1 1 300px;
  }
`

CardTurma.Title = styled.h2`
  color: #fbba3e;
  font-size: 14px;
  font-weight: 600;
`

CardTurma.TextBold = styled.h2`
  color: #3a3a3a;
  font-size: 14px;
  font-weight: 600;
  margin: 0;
`
CardTurma.TextSemiBold = styled.h3`
  color: #898989;
  font-size: 14px;
  font-weight: 600;
`

CardTurma.TextLight = styled.span`
  display: flex;
  color: #898989;
  font-size: 14px;
  font-weight: 400;
  gap: 7px;
`

CardTurma.TextSmall = styled.span`
  color: #898989;
  font-size: 15px;
  font-weight: 400;
  strong {
    color: #3a3a3a;
  }
`

CardTurma.formatData = (data: string) => {
  return format(parseISO(data), 'dd/MM/yyyy')
}

const ResumoPagamento = ({ turmaInfo }: { turmaInfo?: any }) => {
  const { Layout, Title, WarningText } = ResumoPagamento

  return (
    <Layout>
      <Title>Resumo do Pagamento</Title>
      <Repasses turmaInfo={turmaInfo} />
      <WarningText>
        *A geração da cobrança não garante reserva imediata! Após pagamento, aguarde alguns minutos
        e retorne para realizar o agendamento e confirmar sua vaga.
      </WarningText>
    </Layout>
  )
}

ResumoPagamento.Layout = styled.div`
  display: block;
  justify-content: flex-end;
  margin-left: auto;
  max-width: 530px;
  padding: 15px 15px 8px 15px;
  background: #ffffff;
  border: 1px solid #ebebeb;
  border-radius: 8px;
`

ResumoPagamento.Title = styled.h1`
  color: #3a3a3a;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
`
ResumoPagamento.WarningText = styled.h1`
  margin-top: 10px;
  color: #e75656;
  font-size: 12px;
  font-weight: 400;
`

export const TurmasPorCfc = () => {
  const { turmas, agendamento, status } = AgendarStore.useState()
  const { CardContainer, Linha, Celula, ContainerInfoCfc, Circle, PanelAntd, TagPagamento } =
    TurmasPorCfc
  const modalidadesTurmas = turmas.map((turma) => turma.modalidade)
  const totalModalidades = new Set(modalidadesTurmas)

  useEffect(() => {}, [status])

  const qtdVagasTurmasGeral: any = []
  turmas.forEach((turma: any) => qtdVagasTurmasGeral.push(+turma.qtdVagasRegulares))
  const somaVagasTurmasGeral = qtdVagasTurmasGeral.reduce((acc: number, next: number) => {
    return (acc += next)
  }, 0)

  const qtdVagasPreenchidasGeral: any = []
  turmas.forEach((turma: any) => qtdVagasPreenchidasGeral.push(+turma.qtdVagasRegularesPreenchidas))
  const somaVagasPreenchidasGeral = qtdVagasPreenchidasGeral.reduce((acc: number, next: number) => {
    return (acc += next)
  }, 0)

  if (agendamento.readOnly)
    return (
      <Show condition={!agendamento.isCnhSocial}>
        {status === 'PAGO' ? (
          <TagPagamento> Pagamento confirmado </TagPagamento>
        ) : (
          <TagPagamento className="pendente"> Pagamento Pendente </TagPagamento>
        )}
      </Show>
    )

  return (
    <>
      <Collapse
        collapsible="disabled"
        defaultActiveKey={['1']}
        accordion={true}
        bordered={false}
        ghost={true}
      >
        <PanelAntd
          showArrow={false}
          header={
            <Linha>
              <Celula>{agendamento.cfcDestino?.fantasia}</Celula>
              <Celula>
                <ContainerInfoCfc>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      gap: '3px',
                    }}
                  >
                    <span>Turmas</span> <Circle>{turmas.length}</Circle>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      gap: '3px',
                    }}
                  >
                    <span>Períodos</span> <Circle>{totalModalidades.size} </Circle>
                  </div>
                </ContainerInfoCfc>
              </Celula>
              <Celula>
                <QuantidadeVagas
                  quantidadeOcupada={+somaVagasPreenchidasGeral}
                  quantidadeTotal={+somaVagasTurmasGeral}
                />
              </Celula>
              <Celula>
                <Show condition={!agendamento.isCnhSocial}>
                  {status === 'PAGO' ? (
                    <TagPagamento> Pagamento confirmado </TagPagamento>
                  ) : (
                    <TagPagamento className="pendente"> Pagamento Pendente </TagPagamento>
                  )}
                </Show>
                <Show condition={!!agendamento.isCnhSocial}>
                  <TagPagamento> Pagamento CNH Social </TagPagamento>
                </Show>
              </Celula>
            </Linha>
          }
          key="1"
        >
          <CardContainer>
            {turmas.map((turma: any) => {
              return <CardTurma key={turma.id} turma={turma} />
            })}
          </CardContainer>
        </PanelAntd>
      </Collapse>
    </>
  )
}

TurmasPorCfc.TagPagamento = styled.div`
  border: 1px solid #46bda8;
  padding: 8px 16px;
  text-align: center;
  border-radius: 8px;
  background: #e6fdf9;
  color: #46bda8;
  font-weight: 500;
`

TurmasPorCfc.PanelAntd = styled<any>(Panel)`
  background: #f6f6f6;
  border: 1px solid #e1e1e1 !important;
  border-radius: 8px !important;
  .ant-collapse-content-box {
    padding: 0 !important;
  }
`

TurmasPorCfc.Linha = styled.tr`
  font-weight: 600;
  font-size: 14px;
  color: #3a3a3a;
  padding: 7px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 25px;
  width: 100%;
  .boleto {
    margin-right: 15px;
  }
  @media (max-width: 756px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }
`
TurmasPorCfc.ContainerInfoCfc = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  gap: 35px;
  @media (max-width: 756px) {
    gap: 15px;
    justify-content: flex-start;
  }
`
TurmasPorCfc.Celula = styled.td`
  text-align: start;
  ${({ width }) => (width ? `max-width: ${width}px;` : 'flex: 1 1 300px;')}
  @media (max-width: 756px) {
    flex: none;
    width: 100%;
  }
  .pendente {
    border: 1px solid orange;
    color: orange;
  }
`
TurmasPorCfc.Divisor = styled.hr`
  border-top: 1px solid #ccc;
  margin: 0;
`

TurmasPorCfc.Text = styled.h3`
  font-weight: 700;
  font-size: 20px;
  color: #545451;
`

TurmasPorCfc.CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 12px;
  padding: 16px;
  background: #f6f6f6;
  border-top: 1px solid #e1e1e1;
`
TurmasPorCfc.Circle = styled.div`
  background: #fbba3e;
  width: 22px;
  height: 22px;
  border-radius: 15px;
  color: #3a3a3a;
  text-align: center;
`

function removeAcentos(str: string) {
  return str?.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

const GerarCobranca = ({ fantasia }: any) => {
  const { Layout, ButtonBoleto, validate, createBoleto, getBaseUrl } = GerarCobranca
  const [loading, setLoading] = useState(false)

  const state = AgendarStore.useState()
  const dispatch = AgendarStore.useDispatch()

  const cfcsDestino = selectCfcsDestino(state)
  const cfcDestino = cfcsDestino.find((x) => x?.fantasia === fantasia)

  useEffect(() => {
    dispatch(AgendarStore.actions.changeCfcDestino(cfcDestino || null))
  }, [])

  const urlCallBack = useMemo(() => {
    if (!state.paramsPilotar) return null
    const baseURL = getBaseUrl()
    return baseURL
  }, [state.paramsPilotar])

  async function handleClick() {
    if (state.loadingCreateAgendamento) return
    dispatch(AgendarStore.actions.changeCfcDestino(cfcDestino || null))

    const { valid, message } = await validate(state)
    if (!state.agendamento.telefone)
      return notification.error({ message: 'Informe o número de telefone' })
    if (state.agendamento.telefone && state.agendamento.telefone.length < 15) {
      return notification.error({ message: 'Um telefone válido deve conter 11 dígitos' })
    }

    if (!valid) return notification.error({ message })
    setLoading(true)
    createBoleto(dispatch, urlCallBack).finally(async () => {
      setLoading(false)
    })
  }

  return (
    <Layout className="gerar-boleto">
      <ButtonBoleto
        data-cy="btn-gerar-boleto"
        onClick={handleClick}
        loading={loading}
        disabled={state.loadingCreateAgendamento}
        size="large"
        type="primary"
      >
        <span className="name-button">
          <span className="plus">+</span>Criar pedido
        </span>
      </ButtonBoleto>
    </Layout>
  )
}
GerarCobranca.Layout = styled.div`
  justify-content: center;
  display: flex;
  @media (max-width: 756px) {
    width: 100%;
  }
`
GerarCobranca.ButtonBoleto = styled(Button)`
  background: #fbba3e !important;
  color: #ffffff !important;
  border-radius: 6px;
  border: none;
  display: flex;
  justify-content: center;
  gap: 7px;
  align-items: center;
  font-weight: 500;
  max-width: 165px;
  height: 44px;
  width: 100%;
  box-shadow: none !important;
  text-shadow: none !important;
  &:hover {
    background: #fbba3e;
    color: #ffffff;
    filter: brightness(0.9);
  }
  @media (max-width: 756px) {
    max-width: 100%;
  }
  &:disabled {
    background: #c2c2c2 !important;
    color: #ffffff !important;
    border: none;
    cursor: not-allowed;
    &:hover {
      background: #c2c2c2 !important;
      color: #ffffff !important;
    }
  }
  .name-button {
    box-shadow: none !important;
    text-shadow: none !important;
    text-align: center;
    font-weight: 500;
    font-size: 16px;
    display: flex;
    gap: 5px;
    align-items: center;
    .plus {
      font-size: 20px;
      font-weight: 600;
    }
  }
`
GerarCobranca.validate = async (state: IState) => {
  const { cpf, nome, renach, cfcOrigem, cfcDestino } = state.agendamento
  const renachFormatado = renach?.replace(/[_.-]/g, '')
  const invalid = (message: string) => ({ valid: false, message })

  if (!cpf) return invalid('Informe o CPF do aluno!')
  if (!isCpfValid(cpf)) return invalid('CPF Inválido!')
  if (!nome) return invalid('Informe o Nome do aluno!')
  if (!renach) return invalid('Informe o RENACH do aluno!')
  if (renachFormatado && renachFormatado.length < 11) return invalid('RENACH possui 9 dígitos!')
  if (!cfcOrigem?.id) return invalid('Informe o CFC de origem!')
  if (!cfcDestino?.cnpj) return invalid('Informe o CFC de destino!')
  if (
    removeAcentos(cfcOrigem.municipio) === 'GOIANIA' &&
    removeAcentos(cfcOrigem.municipio) !== removeAcentos(cfcDestino.municipio)
  ) {
    return invalid('Se o CFC de Origem é de Goiânia, o CFC de Destino também deve ser de Goiânia')
  }

  return { valid: true, message: '' }
}
GerarCobranca.isEmailValid = (email: string) => {
  const re = /^[^\s@]+@[^\s@]+$/
  return re.test(email)
}
GerarCobranca.isMunicipiosValid = (municipioOrigem: string, municipioDestino: string) => {
  const removeAccents = (value: any) => value?.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  if (removeAccents(municipioDestino) === 'GOIANIA') return true
  return removeAccents(municipioDestino) === removeAccents(municipioOrigem)
}
GerarCobranca.createBoleto = (dispatch: any, urlCallBack?: string | null) => {
  return dispatch(AgendarStore.thunks.createAgendamento(urlCallBack))
}

GerarCobranca.getBaseUrl = () => {
  const search = window.location.search
  const urlSearch = new URLSearchParams(search)
  const baseUrl = urlSearch.get('url_callback')
  return baseUrl
}

export default TurmasDisponiveis

enum DURACAO_TURMA_HORAS_POR_MODALIDADE {
  INTENSIVO = 9,
  MATUTINO = 10,
  VESPERTINO = 10,
  NOTURNO = 10,
}

type Modalidade = 'MATUTINO' | 'VESPERTINO' | 'NOTURNO' | 'INTENSIVO'

export const calculaDataFimTurma = ({
  dataInicio,
  modalidade,
  tipoCurso,
}: {
  dataInicio: string
  modalidade: Modalidade
  tipoCurso: string
}) => {
  const date = new Date(dataInicio)
  const day = date.getDay()

  if (tipoCurso !== 'RENOVACAO') {
    if (modalidade === 'INTENSIVO') {
      if (day === 5) return addDays(new Date(dataInicio), 9)
      if (day === 6) return addDays(new Date(dataInicio), 8)
    }

    if (day === 3 || day === 4 || day === 5) {
      return addDays(new Date(dataInicio), DURACAO_TURMA_HORAS_POR_MODALIDADE[modalidade] + 2)
    }
    return addDays(new Date(dataInicio), DURACAO_TURMA_HORAS_POR_MODALIDADE[modalidade])
  } else {
    return addDays(new Date(dataInicio), 2)
  }
}

const Repasses = ({ turmaInfo }: { turmaInfo: any }) => {
  const { Container, ListaRepasses, RepasseOrigem, ValorTotal, Wrapper } = Repasses
  const {
    agendamento: { cpf, cfcOrigem, cfcDestino, tipoCurso },
    cfcsDestino,
    hasRepasses,
  } = AgendarStore.useState()
  const selectedCfcDestinoCobranca = cfcsDestino.find((cfc) => cfc.id === turmaInfo?.cfc?.id) as any

  const [{ data: repasses, loading, error }, refetch] = useAxios(
    {
      url: '/repasses/agendamento-regular',
      params: {
        cpf,
        cfcOrigemCnpj: cfcOrigem?.cnpj,
        cfcDestinoCnpj: selectedCfcDestinoCobranca?.cnpj,
        tipoCurso,
        hasRepasses,
      },
    },
    { useCache: false, manual: true }
  )

  useEffect(() => {
    if (!selectedCfcDestinoCobranca) return
    refetch().catch((e) => {})
  }, [cpf, cfcOrigem, selectedCfcDestinoCobranca, tipoCurso, hasRepasses])

  if (error) {
    const message = error.response?.data?.message || 'Erro ao buscar repasses!'
    notification.error({ message })
  }

  if (!repasses || !cfcDestino) return null

  return (
    <>
      <TailSpin
        color="#FBBA3E"
        height={50}
        width={50}
        visible={loading}
        wrapperStyle={{
          width: '50px',
          margin: '5px auto',
        }}
      />
      <Show condition={!loading}>
        <Wrapper>
          <Container>
            <ListaRepasses repasse={repasses} />
            <RepasseOrigem repasse={repasses} />
            <ValorTotal valorTotal={repasses?.valorTotal} />
          </Container>
          <GerarCobranca fantasia={selectedCfcDestinoCobranca.fantasia} />
        </Wrapper>
      </Show>
    </>
  )
}

Repasses.Layout = styled.div`
  background-color: #ffffff !important;
`
Repasses.Container = styled.div`
  flex: 1;
  padding: 20px;
  background: #f6f6f6;
  border: 1px dashed #ebebeb;
  border-radius: 8px;
  @media (max-width: 756px) {
    width: 100%;
  }
`
Repasses.Wrapper = styled.div`
  display: flex;
  gap: 25px;
  width: 100%;
  align-items: flex-end;
  @media (max-width: 756px) {
    flex-direction: column;
  }
`

Repasses.ListaRepasses = ({ repasse }: { repasse: RepasseModel }) => {
  let repassesExibicao = JSON.parse(repasse?.repassesExibicao || '[]')

  return repassesExibicao.map((r: any, i: any) => <Repasse repasse={r} key={i} />)
}
Repasses.RepasseOrigem = ({ repasse }: { repasse: RepasseModel }) => {
  let repassesExibicao = JSON.parse(repasse?.repassesExibicao || '[]')

  if (repassesExibicao.length <= 0) return null

  const {
    agendamento: { cotista, cfcOrigem },
  } = AgendarStore.useState()

  const totalRepassesExibicao = repassesExibicao.reduce((v1: any, v2: any) => v1 + v2.valor, 0)
  const valorCfcOrigem = (repasse?.valorTotal || 0) - totalRepassesExibicao

  if (cotista && valorCfcOrigem > 0)
    return <Repasse repasse={{ descricao: `${cotista.nome}`, valor: valorCfcOrigem }} />
  if (valorCfcOrigem > 0)
    return <Repasse repasse={{ descricao: cfcOrigem?.fantasia, valor: valorCfcOrigem }} />

  return null
}
Repasses.ValorTotal = ({ valorTotal }: { valorTotal: number }) => {
  return (
    <Repasse
      repasse={{
        descricao: 'Valor total',
        valor: formatMoeda(valorTotal),
        enfatico: true,
      }}
    />
  )
}

const Repasse = ({ repasse }: { repasse: { descricao: any; valor: any; enfatico?: boolean } }) => {
  const { Container, Values } = Repasse
  return (
    <Container>
      <Values enfatico={repasse.enfatico}>{repasse.descricao}</Values>
      <Values enfatico={repasse.enfatico}>R$ {formatMoeda(repasse?.valor)}</Values>
    </Container>
  )
}
Repasse.Container = styled.div`
  display: flex;
  gap: 4px;
  align-items: flex-end;
  justify-content: space-between;
`
Repasse.Values = styled.span<{ enfatico?: boolean }>`
  color: #3a3a3a;
  font-size: 13px;
  ${(props) => (props.enfatico ? 'font-size: 16px; font-weight: 600' : '')}
`
